const getDefaultAvatar = (string) =>
  string
    .split(" ")
    .map((word) => word.charAt(0))
    .join("")
    .substr(0, 2);

export default getDefaultAvatar;
